import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryPoint } from '../../models/address';

@Pipe({
  name: 'address',
  pure: false
})

export class AddressPipe implements PipeTransform {
  transform(address: DeliveryPoint | null): string {
    if (!address) {
      return '';
    }

    const limit = 60;
    let isFull = false;
    let strString = address.apartment ?? '';

    if (address.house) {
      strString = strString.length ? `${address.house}, ${strString}` : address.house;
    }

    if (address.street) {
      strString = strString.length ? `${address.street}, ${strString}` : `${address.street}, ${strString}`;
    }

    if (address.city && strString.length + address.city.length < limit) {
      isFull = true;
      strString = `${address.city}, ${strString}`;
    }

    return isFull ? strString : `...${strString}`;
  }
}
